import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, ShieldIcon } from 'lucide-react';
import { SEO } from '../../components/SEO';
export const RamenTintingPage = () => {
  return <main data-id="element-1231">
      <SEO title="Ramen Tinten Almere | XPEL Raamfolie | BKCustoms" description="Professionele ramen tinting in Almere vanaf €175. Privacy en UV-bescherming met XPEL premium raamfolie. Hoogwaardige tinting voor optimaal comfort bij BKCustoms." canonical="/diensten/ramen-tinting" data-id="element-1232" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-1233">
        <div className="absolute inset-0 overflow-hidden" data-id="element-1234">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-1235"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wNLF8ocqa3iPQaSqTR3jq1/carwindowtintingfranklintn-768x512.jpg" alt="Ramen Tinting Almere" className="w-full h-full object-cover object-center" data-id="element-1236" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-1237">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1238">
            <span className="text-[#D6281F]" data-id="element-1239">Ramen Tinten Almere</span> -
            Privacy met stijl
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1240">
            Professionele ramen tinting in Almere voor privacy en UV-bescherming
            met stijl. Hoogwaardige tinting voor een luxe uitstraling en
            optimaal comfort.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8" data-id="element-1241">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-1242">
              <span className="mr-2" data-id="element-1243">Direct afspraak maken</span>
              <ArrowRightIcon size={16} data-id="element-1244" />
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-1245">
              Offerte aanvragen
            </Link>
          </div>
        </div>
      </div>
      {/* Service Description Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-1246">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1247">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-1248">
            {/* Image Section */}
            <div className="w-full lg:w-1/2" data-id="element-1249">
              <div className="relative" data-id="element-1250">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-1251"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-1252">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wNLF8ocqa3iPQaSqTR3jq1/carwindowtintingfranklintn-768x512.jpg" alt="Ramen tinten voorbeeld in Almere" className="w-full h-auto object-cover" data-id="element-1253" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="w-full lg:w-1/2" data-id="element-1254">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1255">
                Premium Ramen Tinten in Almere
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-1256">
                Bij BKCustoms in Almere bieden we professionele ramen tinting
                diensten met hoogwaardige folies die niet alleen uw privacy
                verhogen, maar ook bescherming bieden tegen schadelijke
                UV-stralen en hitte.
              </p>
              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-1257">
                Onze ervaren specialisten in Almere zorgen voor een perfecte
                installatie zonder luchtbellen of oneffenheden, voor een
                naadloze en duurzame afwerking die jarenlang mooi blijft.
              </p>
              <div className="space-y-4 mb-8" data-id="element-1258">
                <div className="flex items-center" data-id="element-1259">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1260">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1261" />
                  </div>
                  <span className="text-white/90" data-id="element-1262">Tot 99% UV-bescherming</span>
                </div>
                <div className="flex items-center" data-id="element-1263">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1264">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1265" />
                  </div>
                  <span className="text-white/90" data-id="element-1266">
                    Vermindert hitte in het interieur
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1267">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1268">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1269" />
                  </div>
                  <span className="text-white/90" data-id="element-1270">
                    Verhoogde privacy en veiligheid
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1271">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1272">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1273" />
                  </div>
                  <span className="text-white/90" data-id="element-1274">
                    Verschillende tinten beschikbaar
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-1275">
                <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-1276">
                  <span className="mr-2" data-id="element-1277">Afspraak maken</span>
                  <ArrowRightIcon size={16} data-id="element-1278" />
                </Link>
                <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-1279">
                  Offerte aanvragen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-1280">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1281">
          <div className="text-center mb-16" data-id="element-1282">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1283">
              De <span className="text-[#D6281F]" data-id="element-1284">Voordelen</span> van Ramen
              Tinten in Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1285">
              Ontdek waarom steeds meer autoliefhebbers in Almere kiezen voor
              ramen tinting.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1286">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1287">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1288">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1289" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1290">
                UV Bescherming
              </h3>
              <p className="text-white/80" data-id="element-1291">
                Onze premium folies blokkeren tot 99% van de schadelijke
                UV-stralen, wat uw huid beschermt en het interieur van uw auto
                behoedt voor verkleuring.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1292">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1293">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1294" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1295">
                Hittereductie
              </h3>
              <p className="text-white/80" data-id="element-1296">
                Verminder de binnentemperatuur van uw auto aanzienlijk, wat
                resulteert in minder gebruik van de airconditioning en een
                comfortabelere rijervaring.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1297">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1298">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1299" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1300">
                Verhoogde Privacy
              </h3>
              <p className="text-white/80" data-id="element-1301">
                Bescherm uw persoonlijke bezittingen tegen nieuwsgierige blikken
                en geniet van meer privacy tijdens het rijden zonder het zicht
                naar buiten te belemmeren.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1302">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1303">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1304" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1305">
                Verbeterde Look
              </h3>
              <p className="text-white/80" data-id="element-1306">
                Getinte ramen geven uw auto een elegante, premium uitstraling
                die het totale uiterlijk van uw voertuig verbetert en de waarde
                kan verhogen.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* XPEL Premium Materials Section */}
      <section className="bg-[#0a0a0a] py-20 border-t border-[#222]" data-id="element-1307">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1308">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-1309">
            <div className="w-full lg:w-1/2" data-id="element-1310">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1311">
                XPEL Premium <span className="text-[#D6281F]" data-id="element-1312">Kwaliteit</span>{' '}
                in Almere
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-1313">
                Bij BKCustoms in Almere gebruiken we uitsluitend XPEL raamfolie
                voor al onze tinting diensten. XPEL staat wereldwijd bekend als
                een van de meest hoogwaardige en duurzame merken in de
                automotive industrie.
              </p>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-1314">
                XPEL raamfolie biedt superieure helderheid, warmteafwijzing en
                UV-bescherming, zonder verkleuring of bubbels na verloop van
                tijd. Met XPEL bent u verzekerd van een langdurige, hoogwaardige
                afwerking die voldoet aan de strengste kwaliteitseisen.
              </p>
              <div className="space-y-4 mb-8" data-id="element-1315">
                <div className="flex items-center" data-id="element-1316">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1317">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1318" />
                  </div>
                  <span className="text-white/90" data-id="element-1319">
                    Superieure optische helderheid
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1320">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1321">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1322" />
                  </div>
                  <span className="text-white/90" data-id="element-1323">
                    Verkleurt niet na verloop van tijd
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1324">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1325">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1326" />
                  </div>
                  <span className="text-white/90" data-id="element-1327">
                    Uitstekende warmtereductie
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1328">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1329">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1330" />
                  </div>
                  <span className="text-white/90" data-id="element-1331">
                    Levenslange fabrieksgarantie
                  </span>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/2" data-id="element-1332">
              <div className="relative" data-id="element-1333">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-1334"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl bg-[#0f0f0f] p-8" data-id="element-1335">
                  <div className="text-center" data-id="element-1336">
                    <div className="mb-6 inline-block" data-id="element-1337">
                      <div className="bg-white/5 p-6 rounded-full" data-id="element-1338">
                        <ShieldIcon size={64} className="text-[#D6281F]" data-id="element-1339" />
                      </div>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-4" data-id="element-1340">
                      XPEL Certified Installer in Almere
                    </h3>
                    <p className="text-white/80" data-id="element-1341">
                      Als gecertificeerde XPEL installateur in Almere garanderen
                      wij een perfecte installatie volgens de hoogste
                      standaarden in de industrie.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Pricing Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-1342">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1343">
          <div className="text-center mb-16" data-id="element-1344">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1345">
              Onze <span className="text-[#D6281F]" data-id="element-1346">Prijzen</span> voor Ramen
              Tinten in Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1347">
              Transparante prijzen voor ramen tinting in Almere op basis van
              autotype
            </p>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#222] bg-[#0f0f0f] shadow-lg" data-id="element-1348">
            <div className="overflow-x-auto" data-id="element-1349">
              <table className="w-full text-white" data-id="element-1350">
                <thead data-id="element-1351">
                  <tr className="bg-[#0a0a0a]" data-id="element-1352">
                    <th className="px-6 py-4 text-left font-semibold" data-id="element-1353">
                      Type Auto
                    </th>
                    <th className="px-6 py-4 text-right font-semibold" data-id="element-1354">
                      Prijs
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[#222]" data-id="element-1355">
                  <tr className="hover:bg-[#0a0a0a]/60 transition-colors" data-id="element-1356">
                    <td className="px-6 py-4" data-id="element-1357">Hatchback 3 deurs</td>
                    <td className="px-6 py-4 text-right text-[#D6281F] font-semibold" data-id="element-1358">
                      €175
                    </td>
                  </tr>
                  <tr className="hover:bg-[#0a0a0a]/60 transition-colors" data-id="element-1359">
                    <td className="px-6 py-4" data-id="element-1360">Hatchback 5 deurs</td>
                    <td className="px-6 py-4 text-right text-[#D6281F] font-semibold" data-id="element-1361">
                      €225
                    </td>
                  </tr>
                  <tr className="hover:bg-[#0a0a0a]/60 transition-colors" data-id="element-1362">
                    <td className="px-6 py-4" data-id="element-1363">Coupe</td>
                    <td className="px-6 py-4 text-right text-[#D6281F] font-semibold" data-id="element-1364">
                      €225
                    </td>
                  </tr>
                  <tr className="hover:bg-[#0a0a0a]/60 transition-colors" data-id="element-1365">
                    <td className="px-6 py-4" data-id="element-1366">Sedan</td>
                    <td className="px-6 py-4 text-right text-[#D6281F] font-semibold" data-id="element-1367">
                      €250
                    </td>
                  </tr>
                  <tr className="hover:bg-[#0a0a0a]/60 transition-colors" data-id="element-1368">
                    <td className="px-6 py-4" data-id="element-1369">SUV</td>
                    <td className="px-6 py-4 text-right text-[#D6281F] font-semibold" data-id="element-1370">
                      €280
                    </td>
                  </tr>
                  <tr className="hover:bg-[#0a0a0a]/60 transition-colors" data-id="element-1371">
                    <td className="px-6 py-4" data-id="element-1372">Station</td>
                    <td className="px-6 py-4 text-right text-[#D6281F] font-semibold" data-id="element-1373">
                      €280
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="mt-8 text-center" data-id="element-1374">
            <p className="text-white/70 text-sm" data-id="element-1375">
              * Alle prijzen zijn inclusief BTW en professionele installatie in
              Almere.
              <br data-id="element-1376" />* Prijzen kunnen variëren afhankelijk van specifieke
              aanpassingen of extra wensen.
            </p>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-1377">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-1378">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-1379">
            Klaar voor meer comfort en stijl met ramen tinten in Almere?
          </h2>
          <p className="text-white/80 mb-8" data-id="element-1380">
            Neem contact met ons op voor een persoonlijk advies of maak direct
            een afspraak voor jouw auto bij BKCustoms in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1381">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-1382">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-1383">
              Contact opnemen
            </Link>
          </div>
        </div>
      </section>
    </main>;
};